export const form = {
  formCopyLink: 'Copier le lien',
  formLinkCopied: 'Lien copié !'
}
